import { reactive } from 'vue';

const state = reactive({
  show: false,
  message: '',
  color: ''
});

const snackbarService = {
  showSnackbar(message, color = 'info') {
    state.message = message;
    state.color = color;
    state.show = true;

    setTimeout(() => {
      state.show = false;
    }, 3000); // Auto-hide after 3 seconds
  },
  getState() {
    return state;
  }
};

export default snackbarService;